import request from '#/utils/request';
import { keysToCamel, normalizeListPage } from '#/api/adapters/wireCase';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * 工作倉庫存來源（選來源倉後候選；`ims.stock_return.work_warehouse_sources.search`）。
 * GET `/ims/stock-return/work-warehouse-sources?source_warehouse_id=`
 *
 * Envelope：`warehouse`＋`list`＋`page`（有分頁）。
 * 列：`sourceType`（`INVENTORY_STOCK`｜`PENDING_ALLOCATION`）、`id`、`stockNo`、
 * `mtr`、`location`（可 null）、`unit`、`availableQty`。
 * 唯讀；create／update **仍只**接受 `inv_stock_id`（僅 `INVENTORY_STOCK` 的 `id`）。
 *
 * @param {object} params
 * @param {string} params.sourceWarehouseId
 * @param {number} [params.page]
 * @param {number} [params.pageSize]
 * @param {string} [params.keyword]
 * @param {array} [params.sort]
 * @param {object} [params.filters] 可含 `mtrId`
 */
export async function fetchStockReturnWorkWarehouseSources({
  sourceWarehouseId,
  ...listQuery
} = {}) {
  const { data: raw } = await request.get('/ims/stock-return/work-warehouse-sources', {
    params: listQueryToApiParams({
      page: listQuery.page ?? 1,
      pageSize: listQuery.pageSize,
      keyword: listQuery.keyword ?? '',
      sort: listQuery.sort ?? [],
      filters: {
        ...(listQuery.filters ?? {}),
        ...(sourceWarehouseId ? { sourceWarehouseId } : {}),
      },
    }),
  });

  return {
    message: raw.message,
    route: raw.route,
    warehouse: keysToCamel(raw.warehouse ?? null),
    data: keysToCamel(raw.list ?? []),
    page: normalizeListPage(raw.page ?? {}),
  };
}
